import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr'

@Injectable({
  providedIn: 'root'
})
export class AppLoggerService {

  defaultTimeOut: {
    timeOut: 3000
  };
  constructor(private toastr: ToastrService) { }

  private logIt(message: string, type: string, additionalOptions?: any ) {
    


      switch (type) {
        case "info":
          this.toastr.info(message, "Information",additionalOptions);
          break;
        case "warning":
          this.toastr.warning(message, "Warning",additionalOptions);
          break;
        case "success":
          this.toastr.success(message, "Success", additionalOptions);
          break;
        case "error":
          this.toastr.error(message, "Error", additionalOptions);
          break;
        default:
      }
  }

  log(message, additionalOptions?: any) {
    this.logIt(message, 'info', additionalOptions);
  }
  logWarning(message, additionalOptions?: any) {
    this.logIt(message, 'warning', additionalOptions);
  }

  logSuccess(message, additionalOptions?: any) {
    this.logIt(message, 'success', additionalOptions);
  }

  logError(message, additionalOptions?: any) {
    this.logIt(message, 'error', additionalOptions);
  }/*,
            logAjaxError: function (exc,message) {
                this.logItAjax(exc, message, 'error');
            }*/


}
